import { FaLanguage  } from "react-icons/fa";
import { defineField, defineType } from "sanity";

export default defineType({
  name: "languageBanner",
  title: "Language Banner",
  type: "document",
  icon: FaLanguage ,

  fields: [
    defineField({
      name: "bannerLabel",
      title: "Banner Label",
      type: "multilingualArrayString",
    }),
    defineField({
      name: "buttonLabel",
      title: "Button Label",
      type: "multilingualArrayString",
    })
  ],
  preview: {
    prepare(value) {
      return {
        title: "Language Banner"
      };
    }
  }
});
